import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { OutlineLabel } from './OutlineLabel';
export const Outline = ({ testID = 'outline', ...props }) => {
    const theme = useTheme();
    const [labelHeight, setLabelHeight] = useState(0);
    const flatten = StyleSheet.flatten(props.style);
    const outlineLabelStyle = useMemo(() => {
        return {
            top: -(labelHeight * 0.55 + 1),
        };
    }, [labelHeight]);
    const onOutlineLabelLayout = (event) => {
        setLabelHeight(event.nativeEvent.layout.height);
    };
    return (_jsxs(View, { testID: `${testID}-container`, style: [
            {
                borderWidth: 1,
                paddingHorizontal: 5,
                borderColor: theme.colors.outline,
                borderRadius: 3,
            },
            flatten,
        ], children: [_jsx(OutlineLabel, { testID: `${testID}-label`, style: [outlineLabelStyle, { backgroundColor: flatten.backgroundColor }], label: props.label, labelStyle: props.labelStyle, onLayout: onOutlineLabelLayout }), props.children] }));
};
